export default __webpack_public_path__ + "static/media/2364.6157974a.png";